import { createSelector } from '@ngrx/store';
import { PlantState } from '../reducers/plant.reducer';

export const selectPlantState = (state: any) => state.plant;

export const selectPlants = createSelector(
  selectPlantState,
  (state: PlantState) => state.plants,
);

export const selectPlantsLoading = createSelector(
  selectPlantState,
  (state: PlantState) => state.loading,
);

export const selectPlantError = createSelector(
  selectPlantState,
  (state: PlantState) => state.error,
);
